import axios from "axios";

export default function ReceiptDownloadPdfService(receiptId) {
  return axios.get(process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + receiptId + "/download/pdf", {
    responseType: 'blob',
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
};
